import React from 'react'

import { ROUTE_NAME, API_URL } from '../constants'

import ItemDelete from '../../../components/Delete'

const UserBufferDelete = () => (
  <ItemDelete
    routeName={ROUTE_NAME}
    apiUrl={API_URL}
    label={(item) =>
      `User Buffer (#${item.id}): ${item.user.username} -- ${item.incidentType.name} (${item.incidentType.code}) - ${item.aiLayer.name} - ${item.distance} ${item.unit}`
    }
  />
)

export default UserBufferDelete
